<template>
  <div class="bg-light border" ontouchmove="return false" :style="'height:' + height +'; width:' + width + '; border-color: #efefef'">
    <div class="signature-canvas-container position-relative">
      <canvas ref="canvas" class="signature-canvas"></canvas>
      <small class="position-absolute text-muted"  style="bottom: 0.2em; left: 0.4em">
        {{ $t('Sign here') }}
      </small>
      <button type="button"
              :class="[
          'btn btn-sm btn-link text-danger position-absolute',
          !hasSignature ? 'd-none' : ''
        ]" style="bottom: 0.2em; right: 0.2em" v-on:click.prevent="onClickEraser">
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad';
export default {
  props: {
    imageUrl: {
      default: null,
    },
    height: {
      default: '200px',
    },
    width: {
      default: '100%',
    }
  },
  data() {
    return {
      signPad: null,
      cachedWidth: null,
      hasSignature: false,
    }
  },
  methods: {
    onClickEraser() {
      this.signPad.clear();
      this.hasSignature = false;
      this.$emit('update:modelValue', null)
    },

    resizeCanvas : function() {

      if(this.$refs.canvas.offsetWidth !== this.cachedWidth) { //add
        this.cachedWidth = this.$refs.canvas.offsetWidth;   //add

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        this.$refs.canvas.width = this.$refs.canvas.offsetWidth * ratio;
        this.$refs.canvas.height = this.$refs.canvas.offsetHeight * ratio;
        const ctx = this.$refs.canvas.getContext("2d");
        ctx.scale(ratio, ratio);
      }
    }
  },
  mounted() {
    this.resizeCanvas();

    const vm = this;
    this.signPad = new SignaturePad(this.$refs.canvas, {
      onEnd: function() {
        vm.hasSignature = !this.isEmpty();
        console.log('SignaturePad onEnd', this.isEmpty(), this.toDataURL())
        if(!this.isEmpty()) {
          vm.$emit('update:modelValue', this.toDataURL())
        }
      }
    });
  }
}
</script>

<style scoped>
  .signature-canvas-container{
    height: 100%;
  }
  .signature-canvas{
    height: 100%;
    width: 100%;
    margin: 0 auto;
    border: 3px solid #FFFFFF;
  }
</style>